import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Nav from '../components/Nav/Nav';
import Footer from '../components/Footer/Footer';
import '../App.css';
import '../style/Blog.css';

function Blog() {
  const { isLoading, getArticles, articles, getCategoriesCMS, categoriesCMS, pages } = useAuth();
  const [selectedCategory, setSelectedCategory] = useState('all');
  const navigate = useNavigate();

  useEffect(() => {
   !categoriesCMS.length && getCategoriesCMS();
   !articles.length && getArticles();
   pages("blog");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const stripHtml = (html) => {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
  };

  const formatDate = (d) =>
    d ? new Date(d).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' }) : '';

  const filteredArticles =
    selectedCategory === 'all'
      ? articles
      : articles.filter((a) => a.category?.name?.toLowerCase() === selectedCategory.toLowerCase());

  /* --- séparation featured / autres --- */
  const featured = filteredArticles[0];
  const others   = filteredArticles.slice(1);              // max 3 petites cartes
  const blanks   = Math.max(0, 3 - others.length);            // compléments visuels

  return (
    <div className="one-page">
      <Nav home/>
      <div className="main">
        <div className="wrapper-page">
          <div>
          <div className="wrapper-page-header pad-wrapper">
              <div>
                <h1 className="page-title">Le blog des entrepreneurs</h1>
                <p className="page-subtitle">
                  Astuces, outils et inspirations pour faire évoluer votre business au quotidien.
                </p>
              </div>
            </div>

          <div  className='pad-wrapper pad-wrapper-y'>
            <div>
            {categoriesCMS && <div className="blog-categories">
            <div className='blog-categories-container'>
              <button
                className={`category-btn ${selectedCategory === 'all' ? 'active' : ''}`}
                onClick={() => setSelectedCategory('all')}
              >
                Tous les articles
              </button>
              {categoriesCMS?.map((cat) => (
                <button
                  key={cat.id}
                  className={`category-btn ${selectedCategory === cat.name ? 'active' : ''}`}
                  onClick={() => setSelectedCategory(cat.name)}
                >
                  {cat.name}
                </button>
              ))}
              </div>
            </div>}

            {!isLoading && filteredArticles.length === 0 && (
              <p className="no-articles">Aucun article dans cette catégorie.</p>
            )}

            {!isLoading && filteredArticles.length > 0 && (
              <div className="blog-grid">
                {/* --- ARTICLE EN GRAND --- */}
                <div
                  className="featured-article"
                  onClick={() => navigate(`/blog/${featured.slug}`)}
                >
                  {featured.cover?.url && (
                    <div className="featured-image" style={{backgroundImage: `url(${featured.cover.url})`}}></div>
                  )}
                  <div className="featured-content">
                    <p className="category-label">{featured.category?.name}</p>
                    <h2 className="featured-title">{featured.title}</h2>
                    <p className="featured-excerpt">
                      {stripHtml(featured.content).slice(0, 400)}…
                    </p>
                    <p className="article-date">{formatDate(featured.publishedAt)}</p>
                  </div>
                </div>

                {/* --- 3 CARTES PETITES --- */}
                <div className="grid-articles">
                  {others.map((article) => (
                    <div
                      key={article.id}
                      className="grid-article-card"
                      onClick={() => navigate(`/blog/${article.slug}`)}
                    >
                      {article.cover?.url && (
                        <div className="grid-image"  style={{backgroundImage: `url(${article.cover.url})`}}></div>
                      )}
                      <div className="grid-content">
                        <p className="category-label">{article.category?.name}</p>
                        <h3 className="grid-title">{article.title}</h3>
                        <p className="article-date-blog">{formatDate(article.publishedAt)}</p>
                      </div>
                    </div>
                  ))}

                  {/* placeholders pour compléter si < 3 articles */}
                  {[...Array(blanks)].map((_, i) => (
                    <div key={`ph-${i}`} className="grid-article-placeholder" />
                  ))}
                </div>
              </div>
            )}
</div>
</div>

          </div>
        </div>
      </div>
     {articles?.length && <Footer />}
    </div>
  );
}

export default Blog;
